import React from 'react';
import cn from 'classnames';
import Panel from '../../Panel';
import FeedbacksComponent from '@/Framework/UI/Pages/Landing/Sections/Feedbacks';

import { clearfixStyles } from '@dealroadshow/uikit/core/components/Clearfix';
import aboutUsStyles from '../aboutUs.scss';

const feedbacksSubtitles = [
  `We offer unlimited, 24x7x365 U.S. based phone, email and live-chat support to all stakeholders utilizing our services.
   We don't ask for testimonials. Below is unsolicited feedback we’ve received from clients.`,
];

const Feedbacks = () => (
  <Panel
    classNameWrapper={ cn(aboutUsStyles.topSpace, clearfixStyles.clearfix) }
    title="Providing world-class fanatical 24x7 support"
    subTitles={ feedbacksSubtitles }
  >
    <div className={ aboutUsStyles.contentHolder }>
      <FeedbacksComponent className={ aboutUsStyles.feedbacksWrapper } sliderType="grid" />
    </div>
  </Panel>
);

export default Feedbacks;
